import React, { useEffect, useState, useCallback } from 'react';
import Nav from "../components/Nav";
import Footer from "../components/Footer";
import Header from "../components/Header";
import BottomNavBar from "../components/BottomNavBar";
import CounselorReviewDetails from '../components/CounselorReviewDetails';
import { useNavigate, useSearchParams,useLocation } from "react-router-dom";
import Captcha from '../components/Captcha';
import { useForm, } from "react-hook-form";
import * as counselorInfoAPI from "../services/counselor";
import * as emailSendAPI from "../services/email";
import { Spinner } from 'react-bootstrap';
import toast, { toastConfig } from 'react-simple-toasts';


function CounselorReview(props) {
    const navigate = useNavigate();
    const location = useLocation();
    let [searchParams] = useSearchParams();

    const [loader, setLoader] = useState(false)
    const [studHCode, setHexCode] = useState('');
    const [counRevDetails, setCounRevDetails] = useState('');
    const [captchaValue, setCaptchaValue] = useState("");
    const [captchaError, setCaptchaError] = useState(false);

    toastConfig({
        render: message => <div style={{ backgroundColor: '#cc2427', color: 'white', padding: 10, borderRadius: 10, fontSize: 18, fontWeight: '700' }}>{message}</div>,
    })

    // let hexCode = "";
    useEffect(() => {
        document.title = 'Review | Families of WWII Vetearnas';
        window.scrollTo({ top: 0, behaviour: "smooth" })
    }, []);
    useEffect(() => {
        let hexCode =location?.state?.hexCode ? location.state.hexCode : "";
        if (hexCode === "" ) {
            hexCode = searchParams.get("code")
        }
        setHexCode(hexCode);
    }, [location?.state?.hexCode,searchParams]);
    

    const { handleSubmit } = useForm({defaultValues: {}});

    const getCounselorApi = useCallback(async () => {
        setLoader(true)
        try {
            await counselorInfoAPI.getCouselorReviewInfo(`${studHCode}/counselor/Review`).then((res) => {
                setLoader(false)
                if (res.status === 200) {
                    setCounRevDetails(res.data)
                }else {
                    if(res.status === 204){
                        return 
                    }
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                }
            }).catch(function (error) {
                    setLoader(false)
                    toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                    return error
                });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            return error
        }
    }, [studHCode]);

    useEffect(() => {
        if(studHCode){
            getCounselorApi()
        }  
    }, [getCounselorApi,studHCode]);

    const handleBack = () => {
        navigate("/counselor",{
                state:{hexCode : studHCode}
            })
    }
    const handleNavBack = (to) => {
        navigate(to,{
            state:{hexCode : studHCode}
        })
    }
    const onCaptchaChange = (value) => {
        setCaptchaValue(value)
    }
    const onSubmit = async (data) => {
        if (!captchaValue) {
            setCaptchaError(true)
            return
        } else {
            setCaptchaError(false)
        }

        setLoader(true)

        let InfoObj = {
            firstName: counRevDetails.filledByFirstName,
            lastName: counRevDetails.filledByLastName,
            WebSite: "",
            toEmail: counRevDetails.counselorEmail,
            type: "Counselor"
        }

        try {
            await counselorInfoAPI.postCouselorReviewSubmit(`${studHCode}/counselor/submit`).then(async (res) => {
                if (res) {
                    try {
                        await emailSendAPI.postEmailSend(InfoObj, "send-email").then((res) => {

                            setLoader(false)
                            if (res.status === 200) {
                                navigate("/counselor/thank-you/",{
                                    state:{hexCode : studHCode}
                                });
                            }else if (res.status === 422) {
                                let errorData = res?.data?.errors
                                if (Object.keys(errorData) && Object.keys(errorData).length > 0) {
                                    Object.keys(errorData).forEach((err, index) => {
                                        toast(errorData[err][0], { position: 'top-right', backgroundColor: 'red' })
                                    })
                                }
                            } else {
                                toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                            }
                        }).catch(function (error) {
                            setLoader(false)
                            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                            return error
                        });
                    }
                    catch (error) {
                        setLoader(false)
                        toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
                        return error
                    }
                }
            });
        }
        catch (error) {
            setLoader(false)
            toast('Something went wrong. Please try again', { position: 'top-right', backgroundColor: 'red' })
            
        }

    }
    return (
        <section>
            <Header title="Counselor/Academic Advisor Application" />
            {loader && <div lg={12} md={12} sm={12} className="loaderContainer">
                <Spinner animation="border" variant="primary" /> </div>}
            <div className="container py-3 py-md-4 py-md-5">
                <div className="row">
                    <div className="col-12">
                        <Nav navbType="counselor" handleNavBack={handleNavBack}/>
                        <CounselorReviewDetails
                            counRevDetails={counRevDetails}
                        />
                        <hr />
                        <Captcha onCaptchaChange={onCaptchaChange} captchaError={captchaError} />
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <BottomNavBar handleBack={handleBack}
                                submitButtonTitle="SUBMIT" />
                        </form>
                    </div>
                </div>
            </div>
            <Footer />
        </section>
    );
}

export default CounselorReview;